export default __webpack_public_path__ + "static/media/photo-1-1.db7631a3.png";